// src/app/components/onboarding/modals/BaseModal.tsx
import { lazy, Suspense } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';
import { OnboardingStep } from '@/services/onboardingService';

interface BaseModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onComplete: () => void;
  onBack?: () => void;
  step: OnboardingStep;
  className?: string;
}

// Lazy load all modal components
const modalComponents = {
  WelcomeModal: lazy(() => import('./WelcomeModal')),
  ScopeStatementModal: lazy(() => import('./ScopeStatementModal')),
  ComplianceTeamModal: lazy(() => import('./ComplianceTeamModal')),
  AssetsSuppliersModal: lazy(() => import('./AssetsSuppliersModal')),
  RisksModal: lazy(() => import('./RisksModal')),
  ControlAssessmentModal: lazy(() => import('./ControlAssessmentModal')),
  ControlReviewModal: lazy(() => import('./ControlReviewModal')),
  FollowUpModal: lazy(() => import('./FollowUpModal')),
};

export const BaseModal: React.FC<BaseModalProps> = ({
  isOpen,
  onOpenChange,
  onComplete,
  onBack,
  step,
  className = '',
}) => {
    console.log('BaseModal props:', {
      isOpen,
      onOpenChange,
      onComplete,
      onBack,
      step,
      className,
    });
  const ModalComponent = step.component ? modalComponents[step.component] : null;
  console.log('ModalComponent:', ModalComponent);

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className={`max-w-6xl! w-6xl! bg-transparent shadow-none border-0 cancelDrag ${className}`}>        
        <Suspense fallback={
            <div className="flex items-center justify-center h-full">
              <Loader2 className="h-8 w-8 animate-spin" />
            </div>
          }>
            {ModalComponent && 
            (() => {
              console.log('ModalComponent:', ModalComponent);
              return (
                <ModalComponent 
                  config={step.meta?.config} 
                  onComplete={(data?: any) => {
                    // Save data if provided, then trigger step completion
                    if (data) {
                      console.log('Modal data:', data);
                      // TODO: Save modal data to step config
                    }
                    onComplete();
                  }}
                  onClose={() => onOpenChange(false)}
                  onBack={onBack}
                  isOpen={isOpen}
                  step={step}
                  onOpenChange={onOpenChange}
                  className="cancelDrag max-w-6xl! w-6xl!"
                />
              );
            })()}
          </Suspense>
        
        {/* <div className="flex justify-end space-x-2 pt-4">
          <Button 
            variant="outline" 
            onClick={() => onOpenChange(false)}
          >
            Close
          </Button>
          <Button 
            onClick={onComplete}
            className="bg-primary text-primary-foreground hover:bg-primary/90"
          >
            Continue
          </Button>
        </div> */}
      </DialogContent>
    </Dialog>
  );
};